import { storeToRefs } from 'pinia';
import { useToast } from 'primevue/usetoast';
import { useGlobalStore } from '@hc/stores/useGlobalStore';

export function registerMessageListeners(echo) {

    const globalStore = useGlobalStore();
    const { global, broadcast } = storeToRefs(globalStore);
    const prefix = global.value?.broadcast ?? 'dev';
    const myid = global.value?.myid ?? null;

    if (!myid) {
        return;
    }

    const toast = useToast();
    const hasBroadcastEvent = (scope) => 'function' === typeof broadcast.value?.[scope];

    // 私頻
    echo.join(`${prefix}hc-private-${myid}`)
        // .joining((user) => {
        //     console.log('joining', user);
        // })
        // .leaving((user) => {
        //     console.log('leaving', user);
        // })
        .listen(`.hc.message`, (s) => {
            console.log('presence', s);

            //全域廣播事件
            if (hasBroadcastEvent('private')) {
                broadcast.value.private.call(null, s.message);
            }

            if (s?.message) {
                toast.add({
                    severity: 'contrast',
                    summary: '訊息',
                    detail: s.message,
                    life: 3000,
                    group: 'br',
                });
                //過濾 user_online 通知
                global.value.notify.unshift(s);
            }
        });

    //HC公頻
    echo.channel(`${prefix}hc-public`)
        .listen(`.hc.broadcast`, (s) => {

            //全域廣播事件
            // if (hasBroadcastEvent('public')) {
            //     broadcast.value.public.call(null, s.message);
            // }

            if (!s?.message) {
                getUserOnline();
                return;
            }

            if ('user_online' === s?.type) {
                return;
            }

            toast.add({
                severity: 'info',
                summary: '系統通知',
                detail: s.message,
                life: 3000,
                group: 'br',
            });

            //過濾 user_online 通知
            global.value.notify.unshift(s);

        });
}
